import {Component, OnInit} from '@angular/core';
import {NaviosViagensService} from "./navios-viagens.service";
import {NaviosViagensModel} from "./navios-viagens.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-navios-viagens',
  templateUrl: './navios-viagens.component.html'
})
export class NaviosViagensComponent extends Components implements OnInit {

  viagens: NaviosViagensModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  pageIsAdd = false;
  pageIsUpd = false;
  id_navio = '';

  constructor(
    private naviosViagensService: NaviosViagensService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'navios'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.naviosViagensService.getPaginacao(1,this.itensPorPagina, ['navio', 'porto_descarga', 'porto_carregamento'])
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];

          if (this.global.debug) {
            console.log(this.viagens);
          }
      },
      error => {
        this.func.showErro(error.json());
      });


  }

  delete(viagem) {
    var viagens = this.viagens;
    var naviosViagensService = this.naviosViagensService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarNavio')+viagem.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(viagens);
        }

        var index = viagens.indexOf(viagem);
        viagens.splice(index, 1);

        naviosViagensService.apagar(viagem.id)
          .subscribe(res => {
              this.navios = viagens;
            },
            err => {
              // Revert the view back to its original state
              viagens.splice(index, 0, viagem);
              this.viagens = viagens;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.naviosViagensService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
      },
      error => {
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/navios-viagens/navios-viagens.component.ts